var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.appMode === "service"
    ? _c("div", { staticClass: "app" }, [
        _c("div", { staticClass: "app-body" }, [
          _c("main", { staticClass: "main" }, [
            _c(
              "div",
              { staticClass: "p-0 container-fluid" },
              [_c("router-view")],
              1
            )
          ])
        ])
      ])
    : _c(
        "div",
        { staticClass: "app" },
        [
          _c("AppHeader", {
            attrs: { navItems: _vm.nav },
            on: { showNavBar: _vm.toggleVisible }
          }),
          _vm._v(" "),
          _c("ResponsiveNav", {
            attrs: { visible: _vm.visible, navItems: _vm.nav },
            on: { hideMenu: _vm.hideMenu }
          }),
          _vm._v(" "),
          _c("PageTitle", { attrs: { title: _vm.name, fabList: this.fab } }),
          _vm._v(" "),
          _c("Sessionlogout"),
          _vm._v(" "),
          _c("div", { staticClass: "app-body" }, [
            _c("main", { staticClass: "main" }, [
              _c(
                "div",
                { staticClass: "container-fluid" },
                [_c("router-view")],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("AppFooter")
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6c6ec7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6c6ec7a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 961
// module chunks = 2